export const PLATFORM_LINKS = {
  spotify: { href: "https://open.spotify.com/artist/18OtkFSnmwUZFiPFBMnZIH" },
  appleMusic: { href: "https://music.apple.com/us/artist/moode-art/1861378499" },
  amazonMusic: { href: "https://music.amazon.com/artists/B0G6YS6Y6Q/moode-art" },
  youtube: { href: "https://www.youtube.com/channel/UCG_KKoQ6dDLS8wIN85uzqjg" },
} as const;

export const DISCOGRAPHY_URL = "https://music.apple.com/us/artist/moode-art/1861378499" as const;

export const CONTACT_INFO = {
  label: "Email",
  value: "moode.art.music@gmail.com",
  href: "mailto:moode.art.music@gmail.com",
} as const;
